import React, { useRef } from "react";
import FooterButton from "../FooterButton";
import ProfileVisibility from "./components/ProfileVisibility";
import { useUpdatePersonalInfo } from "hooks/api/useSettings";

function Personalize({ data, isLoading }) {
  const profileRef = useRef();
  const { mutate: updatePersonalInfo, isLoading: updateLoading } =
    useUpdatePersonalInfo({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["account_settings"] });
      },
    });

  return (
    <div className="flex flex-col gap-6">
      <ProfileVisibility
        ref={profileRef}
        data={data?.personalised_settings_data}
        isLoading={isLoading}
      />
      <FooterButton
        isLoading={updateLoading}
        onSave={() => {
          if (profileRef.current.validate()) {
            const payload = profileRef.current.getValues();
            updatePersonalInfo(payload);
          }
        }}
      />
    </div>
  );
}

export default Personalize;
